<template>
  <div>
    <loading-spinner v-if="loading"></loading-spinner>
    <v-row v-else>
      <v-col cols="12" v-if="!billing">
        <v-card class="text-center">
          <v-card-title class="d-block">Billing Account Not Setup</v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" v-else-if="billing.onboardingUrl">
        <v-card>
          <v-card-title>Start earning commission</v-card-title>
          <v-card-subtitle>
            <v-row dense>
              <v-col cols="auto">
                In order to earn commission in the future, you'll need to setup
                an account with
              </v-col>
              <v-col cols="auto">
                <v-img :src="$images.STRIPE" width="40"></v-img>
              </v-col>
            </v-row>
          </v-card-subtitle>
          <v-card-text>
            <v-btn color="performance" :href="billing.onboardingUrl">
              <font-awesome-icon
                :icon="['fab', 'stripe-s']"
                size="lg"
                class="mr-2"
              ></font-awesome-icon>
              Connect to Stripe
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" v-else>
        <partner-billing-history></partner-billing-history>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PartnerBillingHistory from "@/components/portal/PartnerBillingHistory";
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fab } from "@fortawesome/free-brands-svg-icons";
export default {
  name: "PartnerBillingOverview",
  components: { PartnerBillingHistory, FontAwesomeIcon },
  data: () => ({ loading: false }),
  computed: { ...mapGetters({ billing: "billing/partner_billing" }) },
  created() {
    library.add(fab);
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$store
        .dispatch("billing/getPartnerBilling")
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading partner billing."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
